import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import SidebarBriefModal from 'core/modal/SidebarBriefModal';

import { buildRoute } from 'routes';
import useAuthUser from 'hooks/useAuthUser';
import { getWebhook } from 'app/features/webhooks/webhookSaga';
import { hideWebhookBriefDetails } from 'app/features/webhooks/webhookSlice';
import PartnerClickAwayDetails from 'components/partners/PartnerClickAwayDetails';

function WebhookBriefDetailsModal() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const user = useAuthUser();

  const viewData = useMemo(
    () => [
      ...(user?.isSuperAdmin()
        ? [
            {
              label: 'Partner Id',
              data: 'partner_id',
              get: ({ partner_id, partner_name }) => (
                <PartnerClickAwayDetails partnerId={partner_id} label={partner_name} />
              ),
            },
          ]
        : []),
      {
        label: 'URL',
        data: 'url',
      },
      {
        label: 'Object Type',
        data: 'object_type',
      },
      {
        label: 'Description',
        data: 'description',
      },
      {
        label: 'Is Verified ?',
        get: ({ is_verified }) => (is_verified ? 'Yes' : 'No'),
      },
      {
        label: 'Is Active ?',
        get: ({ is_active }) => (is_active ? 'Yes' : 'No'),
      },
    ],
    [],
  );

  const state = useSelector((state) => state.webhooks.show);

  const { showBriefDetailModal, webhookId, isLoading, data } = state;

  useEffect(() => {
    if (webhookId) dispatch(getWebhook(webhookId));
  }, [webhookId]);

  if (!showBriefDetailModal && !webhookId) return <></>;

  return (
    <SidebarBriefModal
      open={showBriefDetailModal ?? false}
      onClose={() => dispatch(hideWebhookBriefDetails())}
      title="Webhook Details"
      onClickView={() => (
        dispatch(hideWebhookBriefDetails()), navigate(buildRoute('webhooks.show', webhookId))
      )}
      viewData={viewData}
      item={data}
      isLoading={isLoading}
    />
  );
}

export default WebhookBriefDetailsModal;